import { DeliverableListingDto } from "../../deliverables/deliverables.objects";

export class DeliverableDialog {

    deliverableStatusMap: Map<number, any[]> = new Map();
    isReadOnly = false;

    successCallback: (response) => void;

    constructor(deliverableStatusList, isReadOnly = false) {
        this.setViewType(isReadOnly);
        this.initialize(deliverableStatusList);
    }

    initialize(deliverableStatusList) {
        $('#editDeliverableDialog .ctms-button-save').on('click', this.saveDialog.bind(this));

        deliverableStatusList.forEach(ds => this.deliverableStatusMap.set(ds[0].DeliverableId, ds.sort((s1, s2) => s1.SortById - s2.SortById)));
    }

    setViewType(isReadOnly: boolean) {
        this.isReadOnly = isReadOnly;

        if (this.isReadOnly) {
            $('#editDeliverableDialog .ctms-button-save').hide();
            $('#editDeliverableDialog .ctms-button-cancel').text('Close');
        } else {
            $('#editDeliverableDialog .ctms-button-save').show()
            $('#editDeliverableDialog .ctms-button-cancel').text('Cancel');
        }
    }

    resetDialog(deliverable: DeliverableListingDto) {
        $('#DeliverableId').val(deliverable.Id);
        $('#DeliverableTypeId').val(deliverable.DeliverableId);
        $('#DeliverableName').text(deliverable.DeliverableName);

        if (this.isReadOnly) {
            $('#DeliverableDueDateRO').text(deliverable.ExpectedDueDate);
            $('#DeliverableCommentRO').text(deliverable.Comment);
            $('#DeliverableModificationNumberRO').text(deliverable.ModificationNumber);
            $('#DeliverableCompletedDateRO').text(deliverable.CompletionDate);
            $('#DeliverableExpirationDateRO').text(deliverable.ExpirationDate ?? '');
            $('#DeliverableStatusRO').text(deliverable.StatusName);

            $('#siteDeliverableForm .ctms-field-submit').hide();
            $('#siteDeliverableForm .ctms-form-text').show();

        } else {
            const f = document.getElementById('siteDeliverableForm') as HTMLFormElement;
            f.reset();
            $('#siteDeliverableForm').removeClass('ctms-invalid-form');

            $('#DeliverableDueDate').val(deliverable.ExpectedDueDate ?? '');
            $('#DeliverableComment').val(deliverable.Comment);
            $('#DeliverableModificationNumber').val(deliverable.ModificationNumber);
            $('#DeliverableCompletedDate').val(deliverable.CompletionDate ?? '');
            $('#DeliverableExpirationDate').val(deliverable.ExpirationDate ?? '');

            // status
            const statusList = this.deliverableStatusMap.get(deliverable.DeliverableId);

            const options = statusList.map((s) => new Option(s.Name, s.Id.toString()));
            $('#DeliverableStatus').empty();
            $('#DeliverableStatus').append(options);
            $('#DeliverableStatus').val(deliverable.StatusId);

            $('#siteDeliverableForm .ctms-field-submit').show();
            $('#siteDeliverableForm .ctms-form-text').hide();
        }
    }

    saveDialog(evt: JQuery.ClickEvent) {
        const token = document.querySelector('input[name="__RequestVerificationToken"]').getAttribute('value');

        const f = document.getElementById('siteDeliverableForm') as HTMLFormElement;

        if (f.checkValidity()) {

            $('#siteDeliverableForm').removeClass('ctms-invalid-form');
            $.ajax({
                url: `/secure/ctms/sites/site-details?handler=UpdateDeliverable`,
                headers: { "RequestVerificationToken": token },
                type: 'POST',
                data: $('#siteDeliverableForm .ctms-field-submit').serialize(),
                success: (resp) => {
                    if (this.successCallback) this.successCallback(resp);
                    $('#editDeliverableDialog').modal('hide');
                }
            });
        } else {
            $('#siteDeliverableForm').addClass('ctms-invalid-form');
        }

        evt.preventDefault();
        evt.stopPropagation();
    }
}